import {
  type QueryKey,
  type UseQueryOptions,
  useQuery,
} from "@tanstack/react-query";
import { getCaterings } from "@/features/caterings/api/get-caterings";
import type { CateringCatalog } from "@/features/caterings/types/catering-catalog.type";
import type { CateringFiltersType } from "@/features/caterings/types/catering-filtes.type";
import type { ApiPlatformResponseType } from "@/types/api-platform.type";

type UseWizardResultsParams = {
  filters: Partial<CateringFiltersType>;
  options?: Omit<
    UseQueryOptions<
      ApiPlatformResponseType<CateringCatalog>,
      unknown,
      ApiPlatformResponseType<CateringCatalog>,
      string[] | QueryKey
    >,
    "queryFn" | "queryKey"
  >;
};

const useCateringsResults = ({ filters, options }: UseWizardResultsParams) => {
  return useQuery({
    queryKey: ["caterings-results", filters],
    queryFn: () => getCaterings(filters as CateringFiltersType),
    ...options,
  });
};

export { useCateringsResults };
